import { render, staticRenderFns } from "./ListActivities.vue?vue&type=template&id=e950b7c6&scoped=true&"
import script from "./ListActivities.vue?vue&type=script&lang=js&"
export * from "./ListActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e950b7c6",
  null
  
)

export default component.exports